import { REV } from 'common/magicGlobals';
import { initWindowGlobals } from 'common/page_config';

// Initialize window globals from page config (replaces _setWindowGlobals.erb)
// Must be called early before any code reads window.env, window.locale, etc.
initWindowGlobals();

// Polyfills removed - native browser support
window.$ = window.$ || require('jquery');
window.jQuery = window.jQuery || window.$;

// Styles extracted by webpack
import 'client/stylesheets/www.index.scss';

import { getGlobals } from 'common/primeval';
import { errorHandlingInit } from 'common/error_handling';
import ConsentManager from 'services/consent_manager';

// Initialize error handling (sets window.appsignal and window.ErrorReporter)
errorHandlingInit(window.RMTREV || REV);
let wwwBundleLoaded = new CustomEvent('wwwBundleLoaded');

// Font Awesome Kit is loaded via layout head script when needed

import { debug } from '../../../app/javascript/utils/debug';

// Track Turbo navigation count to skip initial turbo:load
let turboLoadCount = 0;

// Function to handle globals fetch and initialization
const handleGlobalsLoad = async (source = 'initial') => {
  debug('primeval', `handleGlobalsLoad called from: ${source}`);
  
  const { shouldRedirectToLocale, locale } = await getGlobals();
  
  if (shouldRedirectToLocale && locale !== '') {
    let paths = window.location.pathname.split('/');
    paths.splice(1, 0, locale);
    window.location.pathname = paths.join('/');
    return;
  }
  
  // Initialize ConsentManager only once on first load
  if (source === 'initial') {
    ConsentManager.init();
    
    import(
      /* webpackChunkName: "wwwIndex" */
      /* webpackMode: "eager" */
      /* webpackPrefetch: true */
      /* webpackPreload: true */
      './www.index'
    ).then(() => {
      dispatchEvent(wwwBundleLoaded);
      window.wwwBundleLoaded = true;
    });
  }
  // For Turbo navigations, getGlobals() already dispatches trackingConfigReady event
  // which ConsentManager listens to for updates
};

// Initial page load - fetch globals and initialize
handleGlobalsLoad('initial');

// Re-fetch globals on Turbo navigations to get fresh CSRF token and tracking context
document.addEventListener('turbo:load', () => {
  turboLoadCount++;
  // Skip the FIRST turbo:load - that's the initial page load which we handle above
  // Only fetch globals on subsequent turbo:load events (actual Turbo navigations)
  if (turboLoadCount > 1) {
    handleGlobalsLoad('turbo:load');
  } else {
    debug('primeval', 'Skipping turbo:load #1 (initial page load)');
  }
});
